import * as yup from 'yup';

// At this point in time, the date type in a react form has data in the "YYYYMMMDD" format.
// This should work until the year 10000.
const DATE_REGEX =
	/^([0-9]{4}[-/]?((0[13-9]|1[012])[-/]?(0[1-9]|[12][0-9]|30)|(0[13578]|1[02])[-/]?31|02[-/]?(0[1-9]|1[0-9]|2[0-8]))|([0-9]{2}(([2468][048]|[02468][48])|[13579][26])|([13579][26]|[02468][048])00)[-/]?02[-/]?29)/g;

export const aboveGroundTankDetails = yup.object().shape({
	numberOfTanks: yup
		.number()
		.required('Number of tanks is required.')
		.typeError('Invalid number')
		.moreThan(0, 'Number of tanks must be greater than zero'),
	tankSize: yup
		.number()
		.required('Tank size is required.')
		.typeError('Invalid number')
		.moreThan(0, 'Number of tanks must be greater than zero'),
	contents: yup.string().required('Tank content is required.'),
	// This is set as nullable to suppress a weird error that occurs when form has errors on the second submit
	// attempt. The cause for this null is difficult to track down due to some weirdness with how this app was built,
	// but a combination of nullable and required will prevent the odd error while still catching null as an invalid
	// option.
	tankType: yup.string().nullable().required('Tank type is required.'),
	installer: yup.string().required('Tank installer is required.'),
	timePeriod: yup.string().required('Time period is required.'),
	contentDescription: yup.string().when('contents', {
		is: 'other',
		then: yup.string().required('Content description is required.'),
	}),
	// prettier-ignore
	removalDate: yup.string().when('timePeriod', {
		is: 'temp',
		then: yup.string().matches(DATE_REGEX, 'Invalid date.'),
	}),
});
